import Flag from './icon/Flag'

export {
    Flag
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/components/index.js
// module id = 1467
// module chunks = 0